module.exports = __webpack_public_path__ + "static/media/gazprom.7c59f245.png";